import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { MailOutline as MailOutlineIcon } from '@material-ui/icons';
import {
  Button,
  Typography,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import { UserService } from 'app/services/userService';
import { ContactIcon, ArrowIcon } from 'app/main/components/icons';
import Popover from '@material-ui/core/Popover';
import useAxiosGet from 'hooks/useAxiosGet';

const useStyles = makeStyles(theme => ({
  franchiseLeaderButton: {
    color: theme.palette.text.dynamic
  },
  franchiseLeaderContainer: {
    display: 'flex',
    marginLeft: 20,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      flexDirection: 'column'
    }
  },
  franchiseLeaderIcon: {
    fontSize: 30,
    [theme.breakpoints.down('sm')]: {
      fontSize: 19
    }
  },
  franchiseLeaderText: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 5,
    textAlign: 'left'
  },
  franchiseLeader: {
    fontFamily: 'Sofia-pro',
    fontWeight: 100,
    fontSize: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  franchiseLeaderName: {
    fontFamily: 'Sofia-pro',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem'
    }
  }
}));

const LeaderFranchise = ({ name }) => {
  const user = useSelector(({ auth }) => auth.user);
  const [leaderFranchiseMenu, setLeaderFranchiseMenu] = useState(null);
  const [{ data }, fetch] = useAxiosGet(`/hairdressers`, {
    ignoreCache: true,
    manual: true
  });
  const classes = useStyles();
  const leaderFranchiseClick = event => {
    setLeaderFranchiseMenu(event.currentTarget);
  };
  const leaderFranchiseClose = () => {
    setLeaderFranchiseMenu(null);
  };

  useEffect(() => {
    if (user.hairdresserSelected) {
      fetch({
        url: `/hairdressers/${user.hairdresserSelected.id}/franchisee`
      });
    }
  }, [user]);

  return (
    <>
      {UserService.isManager(user) && (
        <>
          <Button
            className={classes.franchiseLeaderButton}
            onClick={leaderFranchiseClick}
          >
            <div className={classes.franchiseLeaderContainer}>
              <ArrowIcon className={classes.franchiseLeaderIcon} />
              <div className={classes.franchiseLeaderText}>
                <Typography className={classes.franchiseLeader}>
                  Mon franchisé
                </Typography>
                <Typography className={classes.franchiseLeaderName}>
                  {`${data?.firstname} ${data?.lastname}`}
                </Typography>
              </div>
            </div>
          </Button>
          <Popover
            open={Boolean(leaderFranchiseMenu)}
            anchorEl={leaderFranchiseMenu}
            onClose={leaderFranchiseClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            classes={{
              paper: 'py-8'
            }}
          >
            {data?.phone && (
              <MenuItem button role="button">
                <ListItemIcon className="min-w-40">
                  <ContactIcon />
                </ListItemIcon>
                <ListItemText primary={data.phone} />
              </MenuItem>
            )}
            <MenuItem button role="button">
              <ListItemIcon className="min-w-40">
                <MailOutlineIcon />
              </ListItemIcon>
              <ListItemText primary={data?.email} />
            </MenuItem>
          </Popover>
        </>
      )}
    </>
  );
};

export default LeaderFranchise;
